/* Comfort Culture — Concept-exact rising-circle sweep (CC-SWEEP-CONCEPT-0814).
   One-way conveyor: the circle rises from below to cover on hover-enter, then
   CONTINUES up and out the top on hover-leave (it never reverses), and silently
   re-parks below for the next hover. Timing lives in cc-sweep.css (.6s ease).

   Driver copied from the proven NZ Supps port of the NZPerf Concept theme —
   only the selector list is CC-specific. OUT_MS must stay > 600ms.

   NOT handled here: .product-form__submit (PDP/sticky add-to-cart) and
   .cc-hero__cta, which belong to cc-rising-btn.js — two drivers must never
   fight over the same button. */
(function () {
  if (!window.matchMedia || !matchMedia('(hover: hover) and (pointer: fine)').matches) return;
  var SEL = [
    '.shopify-section--slideshow .prose .button',
    '.button--primary:not(.product-form__submit)',
    '.sticky-atc-button',
    'a.button:not([class*="button--"]):not(.skip-to-content-link):not(.cart__checkout-button)'
  ].join(', ');
  var OUT_MS = 650;
  function repark(btn) {
    btn.classList.add('is-sweep-repark');
    void btn.offsetWidth;
    btn.classList.remove('is-sweep-out', 'is-sweep-repark');
  }
  function enter(btn) {
    if (btn.__ccT) { clearTimeout(btn.__ccT); btn.__ccT = 0; }
    if (!btn.classList.contains('cc-sweep')) {
      btn.classList.add('cc-sweep', 'is-sweep-repark');
      void btn.offsetWidth;
      btn.classList.remove('is-sweep-repark');
    } else if (btn.classList.contains('is-sweep-out')) {
      repark(btn);
    }
    btn.classList.add('is-sweep-in');
  }
  function leave(btn) {
    if (!btn.classList.contains('is-sweep-in')) return;
    btn.classList.remove('is-sweep-in');
    btn.classList.add('is-sweep-out');
    btn.__ccT = window.setTimeout(function () { btn.__ccT = 0; repark(btn); }, OUT_MS);
  }
  function host(e) {
    var t = e.target;
    if (!t || !t.closest) return null;
    var btn = t.closest(SEL);
    if (!btn) return null;
    if (e.relatedTarget && btn.contains(e.relatedTarget)) return null;
    return btn;
  }
  document.addEventListener('pointerover', function (e) { var b = host(e); if (b) enter(b); }, true);
  document.addEventListener('pointerout',  function (e) { var b = host(e); if (b) leave(b); }, true);
})();
